<script>
  import {getContext, createEventDispatcher} from 'svelte';
  import Button from '@/widgets/Button.svelte';
  import Modal from '@/widgets/Modal.svelte';
  import {TRADING_GAME} from '../images';
  import {ERROR_CODE} from '../const';
  import lang from '../TradeCompetitionPage.lang';

  export let errorCode;

  const LG = getContext('LG');
  const dispatch = createEventDispatcher();

  function handleClickStop(e) {
    e.stopPropagation();
  }

  function handleClickClose() {
    dispatch('close');
  }
</script>

<style>
  .modal-content {
    padding-bottom: 20px;
  }
</style>

<Modal style="max-width: 480px;width: 90%;">
  <div class="df jcfe lh24 b f16 T2" slot="header">
    <i class="iconfont lh12 f12 T4 cp" on:click={handleClickClose}>&#xe614;</i>
  </div>
  <div class="modal-content fw3 tc">
    {#if errorCode === ERROR_CODE.SUCCESS}
      <img width="92" height="92" src={TRADING_GAME.SUCCESS} alt="joined success" />
      <div>{LG(lang.JoinSuccess)}</div>
    {/if}
    {#if errorCode === ERROR_CODE.SUB_ACCOUNT_NOT_ALLOW}
      <img width="92" height="92" src={TRADING_GAME.WARING} alt="warn" />
      <div>{LG(lang.SubAccountNotAllow)}</div>
    {/if}
  </div>
  <div class="footer df fdc tc" slot="footer" on:click={handleClickStop}>
    <div class="buttons">
      <Button type="default" on:click={handleClickClose}>{LG(lang.OK)}</Button>
    </div>
  </div>
</Modal>
